import { render } from "./ObservationsComponent.vue?vue&type=template&id=be8f0730"
import script from "./ObservationsComponent.vue?vue&type=script&lang=js"
export * from "./ObservationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__